import React from 'react';
import { Box, Tabs, Tab, Paper, Typography } from '@mui/material';
import {
  AccountTree as RepoAlignmentIcon,
  BarChart as AnalyticsIcon
} from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import SnykDashboard from './SnykDashboard';
import SnykRepoAlignmentTable from './SnykRepoAlignmentTable';
import SnykAnalyticsDashboard from './SnykAnalyticsDashboard';

const TAB_MAP = { 'repo-alignment': 1, 'analytics': 2 };
const VIEW_MAP = { 1: 'repo-alignment', 2: 'analytics' };

const SecurityPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewParam = searchParams.get('view') || '';

  const activeTab = TAB_MAP[viewParam] ?? 0;

  const handleTabChange = (_, newTab) => {
    const params = new URLSearchParams(searchParams);
    params.delete('collection');
    const view = VIEW_MAP[newTab];
    if (view) {
      params.set('view', view);
    } else {
      params.delete('view');
    }
    setSearchParams(params, { replace: true });
  };

  return (
    <Box>
      <Paper sx={{ mb: 0 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="All Issues" />
          <Tab
            label="Repo Alignment"
            icon={<RepoAlignmentIcon fontSize="small" />}
            iconPosition="start"
          />
          <Tab
            label="Analytics"
            icon={<AnalyticsIcon fontSize="small" />}
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {activeTab === 0 && <SnykDashboard />}
      {activeTab === 1 && (
        <Box p={3}>
          <Typography variant="h5" gutterBottom>
            <RepoAlignmentIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Repo Alignment
          </Typography>
          <SnykRepoAlignmentTable />
        </Box>
      )}
      {activeTab === 2 && <SnykAnalyticsDashboard />}
    </Box>
  );
};

export default SecurityPage;
